<template>
	<JBox>
		<JBox class="s-mb-6" v-if="form.parentTypeId">
			<label class="s-w-full">{{ $t("products.parentTypeId") }}</label>
			<JBox class="s-text-gray-600">{{ form.parentTypeId }}</JBox>
		</JBox>

		<JBox class="s-mb-6">
			<CFormInput
				:label="$t('products.typeId')"
				:description="$t('products.technicalNameForTheBenefit')"
				componentName="JInputText"
				name="typeId"
				class="s-mb-6"
				v-model="form.typeId"
				@input="handleInput"
				@blur="convertToTechnicalNames"
			/>

			<!-- Is benefit optional benefit? -->
			<CFormInput
				label="Is this benefit optional?"
				description="User can choose from predefined options or enter their own value"
				componentName="JToggle"
				name="isOptional"
				class="s-mb-6"
				v-model="isOptional"
				@input="handleInput"
			/>

			<!-- Optional -->
			<template v-if="isOptional">
				<!-- Is benefit manual value input or there are some options -->
				<CFormInput
					label="What type?"
					componentName="JRadios"
					:options="optionalTypeOptions"
					name="optionaltype"
					class="s-mb-6"
					v-model="optionalType"
					@input="handleInput"
				/>

				<!-- Option Key -->
				<template v-if="optionalType === 'options'">
					<CFormInput
						label="Option key for the first option"
						description="More options can be defined later, no worries."
						componentName="JInputText"
						name="optionKey"
						class="s-mb-6"
						v-model="form.optionKey"
						@input="handleInput"
						@blur="convertToTechnicalNames"
					/>
					<JText></JText>
				</template>

				<!-- Manual Value Input -->
			</template>

			<JText class="s-mt-6 s-text-gray-700 s-text-sm s-font-semibold">Add localized benefit details via JSON</JText>
			<JToggle v-model="hasL10nBenefits" @input="handleInput" />
			<template v-if="hasL10nBenefits">
				<CCodeEditor v-model="l10nBenefits" language="json" @input="handleInput" />
				<JText class="s-text-red-500" v-if="hasBenefitsErrorMessage">{{ hasBenefitsErrorMessage }}</JText>
			</template>
		</JBox>
	</JBox>
</template>

<script>
import snakeCase from "lodash.snakecase"

const benefitInputsExample = () =>
	JSON.stringify(
		{
			"en-US": {
				name: "Benefit name en",
				description: "Benefit description",
				value: "Short value here",
				detailedValue: "Detailed value here"
			},
			"zh-HK": {
				name: "Benefit name zh",
				description: "Benefit description",
				value: "Short value here",
				detailedValue: "Detailed value here"
			}
		},
		null,
		2
	)

export default {
	props: {
		value: {
			type: Object,
			default: () => ({})
		}
	},

	data() {
		return {
			hasL10nBenefits: false,
			hasBenefitsErrorMessage: null,
			isOptional: false, // whether it has optional benefits
			optionalType: "options", // whether optional benefits are supposed to be options or there is manual user input; `options` or `manualInput`
			l10nBenefits: benefitInputsExample(), // JSON as a string
			form: {}
		}
	},

	computed: {
		optionalTypeOptions() {
			return [
				{ name: "Defined options", value: "options" },
				{ name: "Manual user input", value: "manualInput" }
			]
		}
	},

	methods: {
		convertToTechnicalNames() {
			this.form = {
				...this.form,
				typeId: snakeCase(this?.form?.typeId),
				optionKey: snakeCase(this?.form?.optionKey)
			}

			this.handleInput()
		},

		handleInput() {
			const form = { ...this.form }

			// Reset just to be sure
			form.optionKey = undefined
			form.isValueInput = undefined

			// Decide additional properties
			// Benefit can't have options and be isValueInput at the same time
			if (this.isOptional) {
				if (this.optionalType === "options") form.optionKey = this.form.optionKey ? this.form.optionKey : "option_0"
				if (this.optionalType === "manualInput") form.isValueInput = true
			}

			this.$emit("input", { ...form, hasL10nBenefits: this.hasL10nBenefits, l10nBenefits: this.l10nBenefits })
		}
	},

	watch: {
		value: {
			handler(newVal) {
				this.form = { ...newVal }
			},
			immediate: true,
			deep: true
		}
	}
}
</script>
